import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useLocalStorageHook } from '@/hooks/usePersistentStorage.js';
import { gameInProgressStorageKey } from '@/constants/persistentStorage.js';

const useGameStore = defineStore('game', () => {
  const [isGameInProgress, setIsGameInProgress] = useLocalStorageHook(gameInProgressStorageKey, false);

  const gameType = ref(null);
  const gameId = ref(null);
  const gameRoundList = ref([]);
  const isPreGameCompleted = ref(false);

  const setGameType = (type) => {
    gameType.value = type;
  };

  const resetGameType = () => {
    gameType.value = null;
  };

  const setGameId = (id) => {
    gameId.value = id;
  };

  const resetGameId = () => {
    gameId.value = null;
  };

  const setGameRoundList = (list) => {
    gameRoundList.value = list;
  };

  const updateGameRoundItem = ({ roundIndex, data }) => {
    if (!gameRoundList.value[roundIndex]) { return; }

    gameRoundList.value[roundIndex] = { ...gameRoundList.value[roundIndex], ...data };
  };

  const resetGameRoundList = () => {
    gameRoundList.value = [];
  };

  return {
    isGameInProgress,
    gameType,
    gameId,
    gameRoundList,
    isPreGameCompleted,
    setIsGameInProgress,
    setGameType,
    resetGameType,
    setGameId,
    resetGameId,
    setGameRoundList,
    updateGameRoundItem,
    resetGameRoundList,
  };
});

export default useGameStore;
